import SalesDocumentPrint from './SalesDocumentPrint';

/** Sales Portal > Print Sales Orders (module sales-order-print): the dot-matrix form and the office laser. */
export default function SalesOrderPrint() {
  return <SalesDocumentPrint kind="order" />;
}
